const updates = [
  {
    date: '07-29',
    title: '《星光深处的你》第87话更新',
    desc: '最新话已同步上线，男女主角感情线迎来关键转折，下拉式追更体验更流畅。',
    tag: '韩漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-29',
    title: '《深渊游戏》第134话抢先看',
    desc: '悬疑推理类日漫人气作品，本话揭晓关键线索，推理迷不可错过。',
    tag: '日漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-28',
    title: '《我为天帝》第56话免费全集上线',
    desc: '国漫修仙题材力作，主角突破境界的热血章节，画面表现力拉满。',
    tag: '国漫',
    tagColor: 'bg-secondary-200 text-secondary-700',
  },
  {
    date: '07-28',
    title: '《蔷薇之约》第二季第12话更新提醒',
    desc: '都市言情类口碑韩漫，第二季剧情渐入佳境，新角色登场引发热议。',
    tag: '韩漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-27',
    title: '《暗夜追踪者》第203话火热连载中',
    desc: '日漫推理长篇连载突破200话大关，案件复杂度再升级，追更榜单持续霸榜。',
    tag: '日漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-27',
    title: '《灵笼战纪》第42话新增下拉式模式',
    desc: '国漫科幻巨制，新增下拉式阅读模式，追更体验全面升级。',
    tag: '国漫',
    tagColor: 'bg-secondary-200 text-secondary-700',
  },
  {
    date: '07-26',
    title: '《甜蜜的谎言》番外篇限时更新',
    desc: '人气韩漫番外篇独家上线，正片之外的隐藏剧情，粉丝福利不容错过。',
    tag: '韩漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-26',
    title: '追更日历：本周7部热门连载同步更新',
    desc: '整理本周热门连载漫画更新时间表，一键订阅，女神漫画网自动提醒。',
    tag: '追更',
    tagColor: 'bg-foreground-100 text-foreground-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            追更快讯
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            实时追踪连载漫画更新动态，第一时间掌握追更资讯
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="flex gap-4 pb-6 mb-6 border-b border-background-200 last:border-0 last:pb-0 last:mb-0">
              <div className="flex-shrink-0 w-16 text-center">
                <div className="text-xs font-bold text-foreground-500 bg-background-100 rounded-lg py-1.5 px-2 leading-tight">
                  {item.date}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <h3 className="font-heading text-base font-bold text-foreground-900">{item.title}</h3>
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}